export const FETCH_STATE_OF_CHARGE_REQUEST = '[StateOfCharge] FETCH_STATE_OF_CHARGE_REQUEST';
export const FETCH_STATE_OF_CHARGE_SUCCESS = '[StateOfCharge] FETCH_STATE_OF_CHARGE_SUCCESS';
export const FETCH_STATE_OF_CHARGE_FAILURE = '[StateOfCharge] FETCH_STATE_OF_CHARGE_FAILURE';
